export default "__VITE_ASSET__DJBpKY6G__"